import { render, staticRenderFns } from "./FinanceSalarySliceShowTable.vue?vue&type=template&id=50091e6a&scoped=true&"
import script from "./FinanceSalarySliceShowTable.vue?vue&type=script&lang=js&"
export * from "./FinanceSalarySliceShowTable.vue?vue&type=script&lang=js&"
import style0 from "./FinanceSalarySliceShowTable.vue?vue&type=style&index=0&id=50091e6a&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50091e6a",
  null
  
)

export default component.exports